import { Breadcrumbs, Link } from "@mui/material";
import React from "react";

// import { Container } from './styles';

const Breadcrumb: React.FC = () => {
  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="#A4A4A4"
      href="https://daveywater.com/au/"
    >
      Home
    </Link>,
    <Link underline="hover" key="2" color="#A4A4A4" href="/">
      Support
    </Link>,
    <Link underline="hover" key="2" color="#A4A4A4" href="/">
      Product Selector – Heap Pump Calculator
    </Link>,
  ];

  return (
    <Breadcrumbs separator=">>" aria-label="breadcrumb">
      {breadcrumbs}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
